// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list-item__title[data-v-313ce431] {\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
